<template>
  <div>
    <div class="content-item">
      <div class="content-box">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="订单号"
              v-model="where.code"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              placeholder="收件人电话"
              v-model="where.per_phone"
              clearable>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" icon="el-icon-search" :loading="listLoading" @click="getLike">搜索</el-button>
          </el-col>
          <el-col :span="7">
            <el-date-picker
              v-model="exc"
              type="daterange"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" icon="el-icon-s-data" :loading="listLoading" @click="getExc">导出</el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 表格 -->
    <div class="content-item">
      <div class="content-box">
        <el-table
          v-loading="listLoading"
          :data="list"
          element-loading-text="Loading"
          fit
        >
          <el-table-column label="目的地" width="120">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="收件人">
            <template slot-scope="scope">
              {{ scope.row.to_name }}
            </template>
          </el-table-column>
          <el-table-column label="运单号" width="200">
            <template slot-scope="scope">
              <el-link type="primary" :href="onPDF(scope.row.code)" target="_blank">{{ scope.row.code }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="追踪号" width="200">
            <template slot-scope="scope">
              <template v-for="item in scope.row.packages">
                {{ item }} <br />
              </template>
            </template>
          </el-table-column>
          <el-table-column label="重量" align="center" >
            <template slot-scope="scope">
              {{ scope.row.weight }}Kg
            </template>
          </el-table-column>
          <el-table-column label="使用积分" align="center">
            <template slot-scope="scope">
              <el-link style="color: var(--color-next)">{{ scope.row.money }}€</el-link>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status ? 'info' : ''">{{ !scope.row.status ? '正常' : '关闭' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="下单时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.created_at | dateformat }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="" align="right" width="160">
            <template slot-scope="scope">
              <el-popconfirm
                v-if="!scope.row.status"
                title="确认关闭此订单？"
                @confirm="onCancel(scope.row.code)"
              >
                <el-button
                  size="mini"
                  type="primary"
                  slot="reference"
                >关闭订单</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-page">
          <div class="page-container">
            <el-pagination
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              background
              layout="total, prev, pager, next, jumper"
              @current-change="pageLoad"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { user_order, label, cancel } from '../api/api';

export default {
  name: 'Order',
  metaInfo(){
    return {
      title: '我的订单',
    }
  },
  data() {
    return {
      listLoading: false,
      list: [],
      total: 0,
      pageSize: 0,
      currentPage: 0,

      where: {},
      exc: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 列表
    getData() {
      this.listLoading = true
      user_order(this.currentPage, this.where).then(data => {
        this.total = data.total
        this.pageSize = data.per_page
        this.list = data.data
        this.listLoading = false
      })
    },
    // 分页
    pageLoad(page) {
      this.currentPage = page
      this.getData()
    },
    // 搜索
    getLike() {
      this.currentPage = 0
      this.getData()
    },
    onPDF(code) {
      return label(code)
    },
    onCancel(code) {
      cancel(code).then(res => {
        if(res.err) {
          return this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        this.getData()
        this.$message({
          message: '关闭成功，积分已返回',
          type: 'success'
        })
      })
    },
    getExc() {
      window.open('/user/ups_exc?min=' + this.exc[0].toString().substr(0, 10) + '&max=' + this.exc[1].toString().substr(0, 10))
    }
  },
}
</script>